import _ from 'lodash';
import React from 'react';
import autobind from 'autobind-decorator';
import { inject, observer } from 'mobx-react';

import AlbumForm from './album-form';

@inject('albumsStore', 'artistStore', 'userStore')
@observer
class AlbumModalContent extends React.Component {
	render () {
		const { album, handleCloseModal } = this.props;

		return (
			<div className="modal-content">
				<div className="columns">
					<div className="grid-x grid-padding-x">
						<div className="cell small-12">
							<AlbumForm
								album={ album }
								handleImageCrop={ this.handleImageCrop }
								submitAction={ this.onClick }
								cancelAction={ handleCloseModal }
							/>
						</div>
					</div>
				</div>
			</div>
		);
	}

	@autobind
	onClick () {
		const { album, artistStore, userStore } = this.props;
		const artist = artistStore.getArtistByID(album.artistID);
		const user = userStore.getItemByID(artist.userID);

		album.save({ user, artist });
		this.props.handleCloseModal();
	}

	@autobind
	handleImageCrop (imageData) {
		this.props.album.artwork = imageData;
	}
}

export default AlbumModalContent;
